/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A contact linked to a property, enriched with the per-link address type.
 * @export
 * @interface PropertyLinkedContact
 */
export interface PropertyLinkedContact {
    /**
     * 
     * @type {number}
     * @memberof PropertyLinkedContact
     */
    readonly id: number;
    /**
     * PA firm that owns this record
     * @type {number}
     * @memberof PropertyLinkedContact
     */
    companyId: number;
    /**
     * Free-form contact type (e.g. insurance_adjuster, contractor_personnel, homeowner)
     * @type {string}
     * @memberof PropertyLinkedContact
     */
    contactType: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyLinkedContact
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyLinkedContact
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyLinkedContact
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyLinkedContact
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyLinkedContact
     */
    jobTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyLinkedContact
     */
    notes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyLinkedContact
     */
    createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof PropertyLinkedContact
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PropertyLinkedContact
     */
    readonly updatedAt: Date;
    /**
     * Address type of this contact for the property (from the contact-property link).
     * @type {string}
     * @memberof PropertyLinkedContact
     */
    addressType?: string | null;
    /**
     * Whether this contact is the primary contact for the property.
     * @type {boolean}
     * @memberof PropertyLinkedContact
     */
    isPrimary?: boolean;
}

/**
 * Check if a given object implements the PropertyLinkedContact interface.
 */
export function instanceOfPropertyLinkedContact(value: object): value is PropertyLinkedContact {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('contactType' in value) || value['contactType'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PropertyLinkedContactFromJSON(json: any): PropertyLinkedContact {
    return PropertyLinkedContactFromJSONTyped(json, false);
}

export function PropertyLinkedContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyLinkedContact {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'contactType': json['contactType'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'jobTitle': json['jobTitle'] == null ? undefined : json['jobTitle'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'addressType': json['addressType'] == null ? undefined : json['addressType'],
        'isPrimary': json['isPrimary'] == null ? undefined : json['isPrimary'],
    };
}

export function PropertyLinkedContactToJSON(json: any): PropertyLinkedContact {
    return PropertyLinkedContactToJSONTyped(json, false);
}

export function PropertyLinkedContactToJSONTyped(value?: Omit<PropertyLinkedContact, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'contactType': value['contactType'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phone': value['phone'],
        'jobTitle': value['jobTitle'],
        'notes': value['notes'],
        'createdBy': value['createdBy'],
        'addressType': value['addressType'],
        'isPrimary': value['isPrimary'],
    };
}

